import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, onOpen, dataTestId }) {
    return (
        <button
            data-testid={dataTestId}
            onClick={() => onOpen(product)}
            className="group relative text-left bg-white rounded-3xl border border-slate-100 premium-shadow overflow-hidden hover-lift focus:outline-none focus:ring-2 focus:ring-blue-600/40"
        >
            <div className="aspect-[4/5] w-full bg-slate-50 overflow-hidden">
                <img
                    src={product.image}
                    alt={product.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                {product.featured && (
                    <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-slate-900 text-white text-[10px] font-semibold uppercase tracking-wider">
                        Featured
                    </div>
                )}
            </div>
            <div className="p-5 flex items-end justify-between gap-3">
                <div className="min-w-0">
                    {product.brand && (
                        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">{product.brand}</div>
                    )}
                    <div className="font-display font-bold text-slate-900 text-lg leading-tight truncate">
                        {product.name}
                    </div>
                    <div className="mt-1.5 font-semibold text-slate-900">
                        ${product.price?.toFixed(2)}
                    </div>
                </div>
                <div className="h-10 w-10 rounded-full bg-slate-900 grid place-items-center text-white flex-shrink-0 transition-transform group-hover:rotate-45">
                    <ArrowUpRight className="w-4 h-4" />
                </div>
            </div>
        </button>
    );
}
